<div class="relative">
  <canvas id="myBars" baseChart [data]="data" [options]="options" [plugins]="plugins" [type]="'bar'"> </canvas>
</div>
